import { ValidSessionRoute } from '@ferreri/minato-auth-react';
import { PageLayout } from '@ferreri/prever-component-lib/nextjs';
import LocationEdit from '@modules/location/LocationEdit';
import { PAGE_TITLE } from '@utils/pageTitle';

export default function LocationEditPage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayout title={PAGE_TITLE.location}>
          <LocationEdit />
        </PageLayout>
      }
    >
      <PageLayout title={PAGE_TITLE.location}>
        <LocationEdit />
      </PageLayout>
    </ValidSessionRoute>
  );
}
